import {Component , OnInit} from '@angular/core';

import {FormBuilder , FormControl , FormGroup , Validators} from '@angular/forms';
import {FuseConfigService} from '../../../../../core/services/config.service';
import {fuseAnimations} from '../../../../../core/animations';
import {ActivatedRoute , Router} from '@angular/router';
import {map} from 'rxjs/operators';

@Component({
    selector: 'fuse-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class FuseResetPasswordComponent implements OnInit {
  hash;
  email;
  resetPasswordForm: FormGroup;
  resetPasswordFormErrors: any;

  constructor (private fuseConfig: FuseConfigService ,
               private formBuilder: FormBuilder ,
               private route: ActivatedRoute,      private router: Router) {
    this.fuseConfig.setSettings({
      layout: {
        navigation: 'none' ,
        toolbar: 'none' ,
        footer: 'none'
      }
    });

    this.resetPasswordFormErrors = {
      email: {} ,
      password: {} ,
      passwordConfirm: {}
    };
  }

  ngOnInit () {
    this.hash = this.route.snapshot.queryParamMap.get('hash');
    this.email = this.route.snapshot.queryParamMap.get('email');
    this.resetPasswordForm = this.formBuilder.group({
      email: new FormControl({value: null, disabled: true}, Validators.required) ,
      password: [ '' , Validators.required ] ,
      passwordConfirm: [ '' , Validators.required ]
    });

    this.resetPasswordForm.valueChanges.subscribe(() => {
      this.onResetPasswordFormValuesChanged();
    });
    this.resetPasswordForm.setValue({email: this.email, password: '', passwordConfirm: ''});
  }

  onResetPasswordFormValuesChanged () {
    for (const field in this.resetPasswordFormErrors) {
      if (this.resetPasswordFormErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      this.resetPasswordFormErrors[ field ] = {};

      // Get the control
      const control = this.resetPasswordForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.resetPasswordFormErrors[ field ] = control.errors;
      }
    }
  }

  changePass () {
    this.resetPasswordForm.value.email = this.hash;
    this.fuseConfig.changePass({hash: this.hash, password: this.resetPasswordForm.value.password}).pipe(map(
      (res) => {
        if (res[ 'error' ]) {
          // this.errMsg = res[ 'error' ];
        } else {
          console.log('Done');
          this.router.navigate(['/pages/auth/login']);
        }
      })).subscribe();
  }
}

